import React, { Component } from 'react'

import styled from 'styled-components'

/* eslint-disable */
window.NodeList.prototype.forEach = Array.prototype.forEach

window.Node.prototype.contains = function contains(node) {
  if (!(0 in arguments)) {
    throw new TypeError('1 argument is required')
  }

  while ((node = node && node.parentNode)) {
    if (this === node) {
      return true
    }
  }

  return false
}
/* eslint-enable */

export default class EquipmentsSvg extends Component {
  onSvgClick = (e) => {
    const { onClickElement } = this.props

    if (!onClickElement) {
      return
    }

    const interactiveBox = document.getElementsByClassName(
      'elementos-interativos'
    )[0]
    let element = e.target

    // Check if elements exist
    if (element && interactiveBox) {
      const parent = element.parentNode
      const isInteractive = interactiveBox.contains(e.target)

      // Toggle equipment
      if (isInteractive) {
        // If is a group of equipments
        if (!parent.classList.contains('elementos-interativos')) {
          element = parent
        }

        let item = element.classList.item(0)

        // Set gradient fill
        element.classList.toggle('active')

        // Trigger
        onClickElement(item)
      }
    }
  }

  triggerSelected = () => {
    if (!this.svgRef) {
      return
    }
    const interactiveBox = this.svgRef.getElementsByClassName(
      'elementos-interativos'
    )[0]

    if (interactiveBox) {
      const allInteractive = interactiveBox.querySelectorAll('path')
      allInteractive.forEach((ele) => ele.classList.add('clickable'))

      const { currentEquipments, hiddenSvgItems } = this.props
      currentEquipments &&
        currentEquipments.forEach(({ svg_key }) => {
          const element = interactiveBox.getElementsByClassName(svg_key)
          if (element[0]) {
            element[0].classList.add('active')
          }
        })

      hiddenSvgItems &&
        hiddenSvgItems.forEach((id) => {
          const element = this.svgRef.getElementsByClassName(id)
          if (element[0]) {
            element[0].style.cssText = 'fill: #DEDEDE'
            element[0].setAttribute('class', '')
            if (element[0] && element[0].tagName === 'g') {
              element[0]
                .querySelectorAll('path')
                .forEach((ele) => ele.setAttribute('class', ''))
            }
          }
        })
    }
  }

  componentDidUpdate() {
    this.triggerSelected()
  }

  componentDidMount() {
    this.triggerSelected()
  }

  render() {
    const { svg, className, style } = this.props

    const SvgComponent = (props) => (
      <SvgWrapper {...props} dangerouslySetInnerHTML={{ __html: svg }} />
    )

    return (
      <Wrapper className={className} style={style}>
        <SvgComponent
          innerRef={(ref) => {
            this.svgRef = ref
          }}
          onClick={this.onSvgClick}
        />
      </Wrapper>
    )
  }
}

const Wrapper = styled.div``

const SvgWrapper = styled.div`
  margin: 0 auto;

  .clickable {
    cursor: pointer;
    pointer-events: bounding-box;
  }

  svg {
    width: 100% !important;
  }

  .active {
    fill: url(#gradient);
  }
`



// WEBPACK FOOTER //
// ./src/containers/EquipmentsSvg/index.js